const Bb8Api = require('bb_8_api');

const defaultClient = Bb8Api.ApiClient.instance;

defaultClient.basePath = process.env.VUE_APP_API_URL;

const AvailabilityApi = new Bb8Api.AvailabilityApi();
const PartnerApi = new Bb8Api.PartnerApi();
const PropertyApi = new Bb8Api.PropertyApi();
const BookingApi = new Bb8Api.BookingApi();
const PriceApi = new Bb8Api.PriceApi();

export { defaultClient, AvailabilityApi, PartnerApi, PropertyApi, BookingApi, PriceApi };
